import {
  BillableItemIds,
  BillableItemPaymentModel,
  BillableItemStatus,
  BillableItemType,
  CurrencyCode,
  FeatureType
} from '../../enums/billableItem';
import { BillableItem } from '../../interfaces/billableItem';

export const telkomPlans: BillableItem[] = [
  {
    id: BillableItemIds.TelkomPlan.TelkomStarterMonthly,
    name: 'SmartSMS Starter',
    type: BillableItemType.TelkomPlan,
    priceInCents: 9900,
    currencyCode: CurrencyCode.ZAR,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      {
        type: FeatureType.Sms,
        quantity: 300
      },
      {
        type: FeatureType.Contact,
        quantity: 300
      }
    ]
  },
  {
    id: BillableItemIds.TelkomPlan.TelkomBasicMonthly,
    name: 'SmartSMS Basic',
    type: BillableItemType.TelkomPlan,
    priceInCents: 29900,
    currencyCode: CurrencyCode.ZAR,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      {
        type: FeatureType.Sms,
        quantity: 1000
      },
      {
        type: FeatureType.Contact,
        quantity: 1000
      }
    ]
  },
  {
    id: BillableItemIds.TelkomPlan.TelkomProMonthly,
    name: 'Telkom Pro',
    type: BillableItemType.TelkomPlan,
    priceInCents: 49900,
    currencyCode: CurrencyCode.ZAR,
    paymentModel: BillableItemPaymentModel.Monthly,
    status: BillableItemStatus.Active,
    features: [
      {
        type: FeatureType.Sms,
        quantity: 1800
      },
      {
        type: FeatureType.Contact,
        quantity: 1800
      }
    ]
  },
  {
    id: BillableItemIds.TelkomPlan.TelkomFreemium,
    name: 'Telkom Free 100',
    type: BillableItemType.TelkomPlan,
    priceInCents: 0,
    currencyCode: CurrencyCode.ZAR,
    paymentModel: BillableItemPaymentModel.Freemium,
    status: BillableItemStatus.Active,
    features: [
      {
        type: FeatureType.Sms,
        quantity: 100
      },
      {
        type: FeatureType.Contact,
        quantity: 100
      }
    ]
  }
];
